import React from 'react';
import { VisitSummaryCard } from '../components/inspection-questionnaire/summary/VisitSummaryCard';
import { generateSampleVisitSummary } from '../components/inspection-questionnaire/utils/generateVisitSummary';
import { useTranslationWithLanguage } from '../context/language-context';

const VisitSummaryDemo: React.FC = () => {
  const { language } = useTranslationWithLanguage();
  const sampleSummaryData = generateSampleVisitSummary();

  const handleSubmitComment = (comment: string) => {
    console.log('Inspector comment submitted:', comment);
    alert('Comment submitted: ' + comment);
  };

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <VisitSummaryCard
        summaryData={sampleSummaryData}
        language={language}
        onSubmit={handleSubmitComment}
      />
    </div>
  );
};

export default VisitSummaryDemo;